<div class="modal-header">
    <h4 class="modal-title">
        {{ title }}
        @if (target.status === 'Submitted') {
            <span class="badge bg-success ms-2">Submitted</span>
        } @else {
            <span class="badge bg-secondary ms-2">Draft</span>
        }
    </h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
        <!-- Header Section -->
        <div class="form-section-title" style="font-weight: 600; font-size: 15px; border-bottom: 2px solid #dee2e6; padding-bottom: 6px; margin-bottom: 12px">
            Truck / Vehicle Information
        </div>
        <div class="row mb-3">
            <div class="col-md-3 form-group">
                <label for="date">Date</label>
                <wj-input-date id="date" name="date" [(ngModel)]="target.date"></wj-input-date>
            </div>
            <div class="col-md-5 form-group">
                <label for="vehicle">Truck / Vehicle Number</label>
                <wj-combo-box
                    id="vehicle"
                    name="vehicle"
                    [(ngModel)]="target.vehicleEquipmentCode"
                    [itemsSource]="vehicleMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                    [isEditable]="false"
                    (selectedIndexChanged)="onVehicleSelected()"
                ></wj-combo-box>
            </div>
            <div class="col-md-4 form-group">
                <label for="inspector">Inspector</label>
                <wj-combo-box
                    id="inspector"
                    name="inspector"
                    [(ngModel)]="target.inspectorHrRef"
                    [itemsSource]="userMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                    (selectedIndexChanged)="onInspectorSelected()"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <label for="vehicleAssignedTo">Vehicle Assigned To (Name)</label>
                <wj-combo-box
                    id="vehicleAssignedTo"
                    name="vehicleAssignedTo"
                    [(ngModel)]="target.vehicleAssignedToHrRef"
                    [itemsSource]="userMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                    (selectedIndexChanged)="onVehicleAssignedToSelected()"
                ></wj-combo-box>
            </div>
            <div class="col-md-3 form-group">
                <label for="mainCategory">Main Category</label>
                <input type="text" class="form-control" id="mainCategory" name="mainCategory" [ngModel]="target.vehicleMainCategory" [disabled]="true" />
            </div>
            @if (selectedVehicleIsHourly) {
                <div class="col-md-3 form-group">
                    <label for="hourReading">Hour Reading</label>
                    <input
                        type="number"
                        class="form-control"
                        id="hourReading"
                        name="hourReading"
                        [(ngModel)]="target.hourReading"
                        min="0"
                        step="0.01"
                        required
                    />
                </div>
            }
        </div>

        @if (isAdding && previousDamageLoading) {
            <div class="alert alert-info py-2 small mb-3">Loading previous inspection damage notes…</div>
        }
        @if (isAdding && hasPreviousDamageNotes()) {
            <div class="alert alert-secondary py-2 small mb-3">
                <strong>Previous inspection notes</strong>
                @if (previousDamage?.inspectionDate) {
                    <span class="text-muted"> ({{ previousDamage?.inspectionDate | date: 'mediumDate' }})</span>
                }
                @if (previousDamage?.damage?.comments || previousDamage?.damage?.response) {
                    <div class="mt-1">
                        <strong>Damage:</strong>
                        @if (previousDamage?.damage?.response) {
                            <span class="ms-1">{{ previousDamage?.damage?.response }}</span>
                        }
                        @if (previousDamage?.damage?.comments) {
                            <span class="ms-1">— {{ previousDamage?.damage?.comments }}</span>
                        }
                    </div>
                }
                @if (previousDamage?.smoke?.comments || previousDamage?.smoke?.response) {
                    <div class="mt-1">
                        <strong>Smoke smell:</strong>
                        @if (previousDamage?.smoke?.response) {
                            <span class="ms-1">{{ previousDamage?.smoke?.response }}</span>
                        }
                        @if (previousDamage?.smoke?.comments) {
                            <span class="ms-1">— {{ previousDamage?.smoke?.comments }}</span>
                        }
                    </div>
                }
                @if (previousDamage?.newSmoke?.comments || previousDamage?.newSmoke?.response) {
                    <div class="mt-1">
                        <strong>New smoke:</strong>
                        @if (previousDamage?.newSmoke?.response) {
                            <span class="ms-1">{{ previousDamage?.newSmoke?.response }}</span>
                        }
                        @if (previousDamage?.newSmoke?.comments) {
                            <span class="ms-1">— {{ previousDamage?.newSmoke?.comments }}</span>
                        }
                    </div>
                }
                <div class="text-muted mt-1">Use comments on the damage/smoke items below to describe existing vs. new issues.</div>
            </div>
        }

        <!-- Checklist Sections -->
        @for (section of target.sections; track section.id; let i = $index) {
            <div class="card mb-2">
                <div
                    class="card-header d-flex align-items-center justify-content-between py-2"
                    style="cursor: pointer"
                    (click)="toggleSection(i)"
                >
                    <div class="d-flex align-items-center">
                        <fa-icon [icon]="collapsedSections[i] ? faChevronRight : faChevronDown" class="me-2" style="width: 14px"></fa-icon>
                        <strong>{{ section.name }}</strong>
                        @if (section.notApplicable) {
                            <span class="badge bg-secondary ms-2">N/A</span>
                        }
                    </div>
                    @if (i > 0) {
                        <div class="form-check mb-0" (click)="$event.stopPropagation()">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                [id]="'na_' + i"
                                [name]="'na_' + i"
                                [(ngModel)]="section.notApplicable"
                                (ngModelChange)="onNotApplicableChanged(i)"
                            />
                            <label class="form-check-label" [for]="'na_' + i">Section Not Applicable</label>
                        </div>
                    }
                </div>
                @if (!collapsedSections[i] && !section.notApplicable) {
                    <div class="card-body py-2 px-3">
                        @if (isConnexSection(i)) {
                            <div class="row mb-2">
                                <div class="col-md-4 form-group">
                                    <label for="connexNumber">Connex Number</label>
                                    <input type="text" class="form-control form-control-sm" id="connexNumber" name="connexNumber" [(ngModel)]="target.connexNumber" />
                                </div>
                            </div>
                        }
                        @if (isTrailerSection(i)) {
                            <div class="row mb-2">
                                <div class="col-md-4 form-group">
                                    <label for="jobTrailerNumber">Job Trailer Number</label>
                                    <input type="text" class="form-control form-control-sm" id="jobTrailerNumber" name="jobTrailerNumber" [(ngModel)]="target.jobTrailerNumber" />
                                </div>
                            </div>
                        }
                        <table class="table table-sm table-bordered mb-2" style="font-size: 13px">
                            <thead>
                                <tr>
                                    <th style="width: 40%">Item</th>
                                    <th style="width: 14%">Response</th>
                                    <th style="width: 24%">Comments</th>
                                    <th style="width: 12%">Corrected?</th>
                                    <th style="width: 10%"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of section.items; track item.id; let j = $index) {
                                    <tr [id]="'vi-item-' + item.id">
                                        <td class="align-middle">{{ item.question }}</td>
                                        <td>
                                            <select
                                                class="form-select form-select-sm"
                                                [(ngModel)]="item.response"
                                                [name]="'response_' + i + '_' + j"
                                            >
                                                <option value="">-- Select --</option>
                                                <option value="Compliant">Compliant</option>
                                                <option value="Non-Compliant">Non-Compliant</option>
                                                <option value="N/A">N/A</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                class="form-control form-control-sm"
                                                [(ngModel)]="item.comments"
                                                [name]="'comments_' + i + '_' + j"
                                            />
                                        </td>
                                        <td>
                                            @if (item.response === 'Non-Compliant') {
                                                <select
                                                    class="form-select form-select-sm"
                                                    [(ngModel)]="item.corrected"
                                                    [name]="'corrected_' + i + '_' + j"
                                                    [disabled]="!canEdit"
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>
                                            }
                                        </td>
                                        <td class="text-center align-middle">
                                            @if (isDamageItem(item)) {
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-outline-secondary"
                                                    (click)="toggleItemPhotos(item.id)"
                                                    [title]="isItemExpanded(item.id) ? 'Hide photos' : 'Add or view photos'"
                                                    [disabled]="!canEdit"
                                                >
                                                    <fa-icon [icon]="faCamera"></fa-icon>
                                                    @if (photoCountFor(item) > 0) {
                                                        <span class="badge bg-primary ms-1">{{ photoCountFor(item) }}</span>
                                                    }
                                                </button>
                                            }
                                        </td>
                                    </tr>
                                    @if (isDamageItem(item) && isItemExpanded(item.id)) {
                                        <tr>
                                            <td colspan="5" class="bg-light py-2">
                                                <div class="small fw-semibold mb-2">Damage photos</div>
                                                <div class="d-flex flex-wrap gap-2 mb-2">
                                                    @for (url of visibleExistingFor(item); track url) {
                                                        <div class="position-relative">
                                                            <img
                                                                [src]="existingPhotoSrc(url)"
                                                                alt="Damage photo"
                                                                class="rounded border"
                                                                style="width: 96px; height: 96px; object-fit: cover; cursor: pointer"
                                                                (click)="openExistingPhoto(url)"
                                                            />
                                                            @if (canEdit) {
                                                                <button
                                                                    type="button"
                                                                    class="btn btn-sm btn-danger position-absolute top-0 end-0 p-0 px-1"
                                                                    style="line-height: 1"
                                                                    (click)="removeExistingPhoto(item, url)"
                                                                >
                                                                    <fa-icon [icon]="faTrash"></fa-icon>
                                                                </button>
                                                            }
                                                        </div>
                                                    }
                                                    @for (photo of pendingPhotosFor(item.id); track $index) {
                                                        <div class="position-relative">
                                                            @if (photo.url) {
                                                                <img
                                                                    [src]="photo.url"
                                                                    alt="Pending upload"
                                                                    class="rounded border"
                                                                    style="width: 96px; height: 96px; object-fit: cover"
                                                                />
                                                            }
                                                            <button
                                                                type="button"
                                                                class="btn btn-sm btn-danger position-absolute top-0 end-0 p-0 px-1"
                                                                style="line-height: 1"
                                                                (click)="removePendingPhoto(item.id, photo)"
                                                            >
                                                                <fa-icon [icon]="faTrash"></fa-icon>
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                                @if (canEdit) {
                                                    <div
                                                        class="border border-2 border-dashed rounded p-3 text-center small"
                                                        [class.border-primary]="isDragOverItem(item.id)"
                                                        (drop)="onItemPhotoDrop(item, $event)"
                                                        (dragover)="onItemPhotoDragOver(item, $event)"
                                                        (dragleave)="onItemPhotoDragLeave($event)"
                                                    >
                                                        Drag and drop images here, or
                                                        <label class="text-primary mb-0" style="cursor: pointer">
                                                            browse
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                multiple
                                                                class="d-none"
                                                                (change)="onItemPhotoChanged(item, $event)"
                                                            />
                                                        </label>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    }
                                }
                            </tbody>
                        </table>
                        <div class="row mb-2">
                            <div class="col-12 form-group">
                                <label [for]="'sectionComments_' + i">Notes / Comments on what is missing or found damaged</label>
                                <textarea
                                    class="form-control"
                                    [id]="'sectionComments_' + i"
                                    [name]="'sectionComments_' + i"
                                    [(ngModel)]="section.comments"
                                    rows="2"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }

        <!-- Footer Section -->
        <div class="form-section-title" style="font-weight: 600; font-size: 15px; border-bottom: 2px solid #dee2e6; margin-top: 16px; margin-bottom: 12px">
            Summary
        </div>
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="notes">Notes</label>
                <textarea class="form-control" id="notes" name="notes" [(ngModel)]="target.notes" rows="3"></textarea>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <label for="signedBy">Checklist Signed By</label>
                <input type="text" class="form-control" id="signedBy" name="signedBy" [(ngModel)]="target.signedBy" />
            </div>
            <div class="col-md-3 form-group">
                <label for="signedOn">Signed On</label>
                <wj-input-date id="signedOn" name="signedOn" [(ngModel)]="target.signedOn" [isRequired]="false"></wj-input-date>
            </div>
        </div>
    </div>
    <div class="modal-footer vi-modal-footer">
        <button id="btnSaveDraft" type="button" class="btn btn-outline-secondary" (click)="saveDraft()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span><fa-icon [icon]="faSave"></fa-icon>&nbsp;@if (target.status === 'Submitted') { Save } @else { Save Draft }</span>
            }
        </button>
        <button id="btnSubmit" type="submit" class="btn btn-primary" (click)="submit()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Submitting</span>
            } @else {
                <span><fa-icon [icon]="faPaperPlane"></fa-icon>&nbsp;Submit</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
